module.exports = __webpack_public_path__ + "static/media/0003.177d7c93.jpg";